import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, Phone } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-navy text-white">
    <div className="container-tight py-20">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center">
            <img src="/assets/logo.png" alt="My Hoom" className="h-12 w-auto bg-white rounded-md p-2" />
          </div>
          <div className="mt-5 text-[10px] tracking-[0.24em] uppercase text-gold">Advisory · Investment</div>
          <p className="mt-5 text-white/70 font-serif text-2xl leading-snug max-w-md">
            {BRAND.tagline}.
          </p>
          <p className="mt-3 text-white/55 text-sm leading-relaxed max-w-md">
            A personalised, transparent real estate advisory built for homebuyers and investors across Bengaluru and Dubai.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="eyebrow text-gold">Navigate</div>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/75 hover:text-gold transition-colors text-sm">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="eyebrow text-gold">Contact</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-3 text-white/80">
              <Phone size={14} className="text-gold" /> {BRAND.phoneIN} <span className="text-white/40">· Bengaluru</span>
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <Phone size={14} className="text-gold" /> {BRAND.phoneAE} <span className="text-white/40">· Dubai</span>
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <Mail size={14} className="text-gold" /> {BRAND.email}
            </li>
          </ul>

          <div className="mt-7 flex items-center gap-4">
            <a href={BRAND.socials.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/15 hover:border-gold hover:text-gold flex items-center justify-center transition-colors"><Instagram size={16} /></a>
            <a href={BRAND.socials.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn" className="h-10 w-10 rounded-full border border-white/15 hover:border-gold hover:text-gold flex items-center justify-center transition-colors"><Linkedin size={16} /></a>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/50">
        <span>© {new Date().getFullYear()} My Hoom Advisory. All rights reserved.</span>
        <span>Bengaluru, India · Dubai, UAE</span>
      </div>
    </div>
  </footer>
);

export default Footer;
